export const decl = (nArg = 0, root = '', ends = ['', '', '']) => {
  const n = Math.abs(nArg);
  return root + ends[n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2];
}
